/* @flow */
import * as React from 'react';

import EventTracking from 'lib/EventTracking';
import Link from 'components/Link';
import Row from 'components/Row';
import Text from 'components/Text';

export type Props = {
  showWarning: ?boolean,
  numberOfClassesLimit: number,
  numberOfRemainingClasses: number,
  isExistingGroup: boolean,
};

export const limitReachedEventKey = 'limit_reached_banner';
export const proactiveEventKey = 'proactive_banner';
export const planLinkEventKey = 'plan_link';
export const existingGroupWarningCopy = 'Announcements aren’t available for this class.';
export const newGroupWarningCopy = 'Announcements will be disabled for this class.';

class GroupCreationLimitNotice extends React.Component<Props> {
  componentDidMount() {
    this.trackEvent('view');
  }

  trackEvent = (event: string) => {
    if (!this.props.numberOfClassesLimit) {
      return;
    }

    const basePrefix = 'free_product_limits.create_class_modal';
    const warningPrefix = this.props.showWarning ? limitReachedEventKey : proactiveEventKey;
    EventTracking.trackKey(`${basePrefix}.${warningPrefix}.${event}`);
  };

  planLink(linkText: string) {
    return (
      <Link
        href="https://www.remind.com/plans"
        target="_blank"
        weight="semibold"
        onClick={() => this.trackEvent('plan_link.click')}>
        {linkText}
      </Link>
    );
  }

  renderLimitInfo() {
    const { numberOfRemainingClasses } = this.props;
    return (
      <Text size="xsmall" align="left" lineHeight="large">
        This school doesn’t have a {this.planLink('Remind Plan')}. You can create{' '}
        {numberOfRemainingClasses} more classes with your free account.
      </Text>
    );
  }

  renderLimitWarning() {
    const { numberOfClassesLimit, isExistingGroup } = this.props;
    const warningText = isExistingGroup ? existingGroupWarningCopy : newGroupWarningCopy;
    return (
      <Text size="xsmall" align="left" lineHeight="large">
        <Text weight="semibold" data-test="creation-limit-warning" color="lava">
          {warningText}
        </Text>
        {/* TODO: fetch membership limit from backend instead of hardcoding */}
        <Text element="div">
          This school doesn’t have a {this.planLink('Remind Plan')} and you have exceeded the{' '}
          {numberOfClassesLimit} class limit for free accounts.
        </Text>
      </Text>
    );
  }

  render() {
    return (
      <Row size="xxsmall">
        {this.props.showWarning ? this.renderLimitWarning() : this.renderLimitInfo()}
      </Row>
    );
  }
}

export default GroupCreationLimitNotice;
